import HmEventRegistry from './../model/HmEventRegistry';
import CoreAjax from './CoreAjax';
import UrlManager from './../model/UrlManager';
import NativeAjax from './NativeAjax';
/*
 * Common Ajax for the application.
 * Depends on React fetch
 *
 */
 var HawkEye = function(data){
	 
	var url = UrlManager.getUrlForAction("TRACKING_URL");
 	var availableMethods = ['GET','POST','PUT'];
 	var dataStr = "";

 	if(typeof data === 'object'){
 		try{
 			dataStr = JSON.stringify(data);
 		}catch(e){
 			console.error("Error occurred while processing the data:",e);
 		}
 	}else{
 		console.warn("Data is not in the form of an object");
 	}


 	this.get = function(success, failure){
 		this.connect('GET',success, failure);
 	}

 	this.post = function(success, failure){
 		this.connect('POST',success, failure);
 	}

 	this.put = function(success, failure){
 		this.connect('PUT',success, failure);	
 	}

 	this.connect = function(method, success, failure){

 		var successCallback = function(result){ 			

 			try{
 				if(typeof success === "function"){
 					success.apply(this,[result]); 
 				}
 			}catch(e){
 				console.error("Error occurred while calling the success handler:",e);
 			}
 		}

 		var failureCallback = function(error){
 			
 			try{
 				if(typeof failure === "function"){
 					failure.apply(this,[error]);
 				}
 			}catch(e){
 				console.error("Error occurred while calling the failure handler:",e);
 			}
 		}


 		if(availableMethods.indexOf(method) === -1){
			//if method not defined, default is applied
			method = availableMethods[0];
		}

		//new CoreAjax(url,data).connect(method,successCallback,failureCallback);
		new NativeAjax(url,data).enableCORS().post(successCallback,failureCallback);
	}
	
}

export default HawkEye;


// WEBPACK FOOTER //
// ./src/util/HawkEye.js